import React from 'react';
import { tarifsKeywords } from '../topKeywords';

const rows = [
  {
    type: 'Studio / T1 très encombré',
    surface: '20–30 m²',
    fourchette: '800 € – 1 500 €',
  },
  {
    type: 'Appartement T2 / T3 insalubre',
    surface: '40–70 m²',
    fourchette: '1 500 € – 3 000 €',
  },
  {
    type: 'Grande maison insalubre',
    surface: '90–150 m²',
    fourchette: '3 000 € – 6 000 €',
  },
  {
    type: 'Syndrome de Diogène extrême',
    surface: 'Selon volume de déchets',
    fourchette: 'Sur devis détaillé',
  },
];

export const Tarifs: React.FC = () => {
  return (
    <div className="bg-slate-50">
      <section className="border-b border-slate-200 bg-white">
        <div className="" />
        <div className="max-w-6xl mx-auto px-4 py-10 lg:py-14">
          <p className="text-xs font-semibold uppercase tracking-wide text-primary mb-2">
            Tarifs indicatifs · Nettoyage logement insalubre
          </p>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">
            Tarif nettoyage logement insalubre et prix nettoyage maison insalubre 06 / 83
          </h1>
          <p className="text-sm text-slate-600 mb-3 max-w-3xl">
            Les <strong>tarifs de nettoyage de logements insalubres</strong> dépendent
            principalement de la surface, du volume de déchets à évacuer, de l’accessibilité et du
            niveau de désinfection nécessaire.
          </p>
          <p className="text-xs text-slate-500">
            Page référente pour des recherches comme :{' '}
            <em>{tarifsKeywords.slice(0, 4).join(', ')}</em>
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-10 lg:py-14">
        <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm">
          <table className="min-w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase text-slate-500">
              <tr>
                <th className="px-4 py-3 text-left">Type de logement</th>
                <th className="px-4 py-3 text-left">Surface</th>
                <th className="px-4 py-3 text-left">Fourchette de prix TTC</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.type} className="border-t border-slate-100">
                  <td className="px-4 py-3 text-slate-800">{row.type}</td>
                  <td className="px-4 py-3 text-slate-600">{row.surface}</td>
                  <td className="px-4 py-3 text-slate-900 font-semibold">
                    {row.fourchette}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-xs text-slate-500">
          Ces montants sont donnés à titre indicatif pour le 06 et le 83. Un{' '}
          <strong>devis personnalisé</strong> est systématiquement réalisé après échange et photos
          du logement.
        </p>
      </section>
    </div>
  );
};

